// extracted by mini-css-extract-plugin
module.exports = {"root":"NavigationSection_root___KSiq","title":"NavigationSection_title__Zwmsw","list":"NavigationSection_list__cPmKA"};